// OpenAI Ads Pixel merkezi utility — registration_completed event'i buradan geçer.
const oaiq = (...args) => {
  if (typeof window !== "undefined" && typeof window.oaiq === "function") {
    window.oaiq(...args);
    return true;
  }
  return false;
};

// Geçici test yardımcısı — console'dan __resetOaiqReg("email") ile tek-gönderim anahtarı temizlenir,
// böylece aynı e-postayla tekrar test edilebilir.
if (typeof window !== "undefined") {
  window.__resetOaiqReg = (key) => {
    const k = `oaiq_registration_completed${key ? `_${key}` : ""}`;
    window.sessionStorage?.removeItem(k);
    console.log(`[OAIQPixel] test anahtarı temizlendi: ${k} — aynı e-postayla tekrar kayıt deneyebilirsiniz`);
  };
}

// Kayıt gerçekten başarıyla tamamlandığında BİR KEZ gönderir.
// sessionStorage bayrağı StrictMode, re-render, çift submit ve sayfa yenileme kaynaklı kopyaları engeller.
// key: aynı oturumda farklı kayıtları ayırmak için (ör. e-posta).
export const trackOaiqRegistration = (key) => {
  const storageKey = `oaiq_registration_completed${key ? `_${key}` : ""}`;
  console.log(
    "[OAIQPixel] registration event tetiklendi | key:", key,
    "| storageKey:", storageKey,
    "| typeof window.oaiq:", typeof window.oaiq
  );
  try {
    if (typeof window !== "undefined" && window.sessionStorage?.getItem(storageKey)) {
      console.warn(
        `[OAIQPixel] ATLANDI — bu kayıt için event zaten gönderildi (sessionStorage: ${storageKey}).`,
        `Tekrar test için console'a yazın: __resetOaiqReg(${JSON.stringify(key || "")})`
      );
      return;
    }
    if (typeof window !== "undefined") window.sessionStorage?.setItem(storageKey, "1");
  } catch (e) { /* storage erişilemezse tek seferlik in-memory davranış */ }
  const args = ["measure", "registration_completed", { type: "customer_action" }];
  console.log("[OAIQPixel] event çağrısı:", `oaiq("${args[0]}", "${args[1]}", ${JSON.stringify(args[2])})`);
  const sent = oaiq(...args);
  if (sent) {
    console.log("[OAIQPixel] registration_completed window.oaiq üzerinden gönderildi (SDK yüklü veya kuyruğa alındı)");
  } else {
    console.error("[OAIQPixel] HATA — window.oaiq tanımsız, event gönderilemedi! Pixel setup kodu yüklenmemiş olabilir.");
  }
};
